import { useState } from "react";
import { channelRacks } from "@/mocks/gossip";

export default function ChannelRack() {
  const [active, setActive] = useState<string | null>(null);

  return (
    <section id="channels" className="bg-background-50 py-10 md:py-14">
      <div className="mx-auto w-full px-4 md:px-6">
        <div className="mb-6 flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-1 text-xs font-semibold uppercase tracking-widest text-secondary-500">
              入口分舱 · 按题材落座
            </p>
            <h2 className="font-display text-2xl font-black text-foreground-950 md:text-3xl">
              吃瓜分舱，想去哪舱点哪舱
            </h2>
          </div>
          <p className="max-w-md text-sm text-foreground-600">
            人物、商业、作品、实锤、考古、社区——六舱井水不犯河水，看完新进展再去对应舱里把细节挖透。
          </p>
        </div>

        <div className="grid grid-cols-2 gap-4 lg:grid-cols-3">
          {channelRacks.map((rack) => {
            const isActive = active === rack.key;
            return (
              <button
                key={rack.key}
                type="button"
                onClick={() => setActive(isActive ? null : rack.key)}
                className={`flex items-start gap-4 rounded-xl border p-5 text-left transition-all ${
                  isActive
                    ? "border-accent-400 bg-accent-50"
                    : "border-background-200 bg-background-100 hover:border-foreground-300"
                }`}
              >
                <span
                  className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg ${
                    isActive ? "bg-accent-500 text-background-50" : "bg-foreground-950 text-background-50"
                  }`}
                >
                  <i className={`${rack.icon} text-xl`}></i>
                </span>
                <span className="min-w-0 flex-1">
                  <span className="flex items-center justify-between gap-2">
                    <span className="text-base font-bold text-foreground-950">{rack.name}</span>
                    <span className="inline-flex items-center gap-1 whitespace-nowrap text-xs text-secondary-600">
                      <i className="ri-archive-line"></i>
                      {rack.count}
                    </span>
                  </span>
                  <span className="mt-0.5 block truncate text-sm text-foreground-600">{rack.desc}</span>
                  <span
                    className={`mt-2 inline-flex items-center gap-1 text-xs font-medium ${
                      isActive ? "text-accent-800" : "text-primary-700"
                    }`}
                  >
                    进入分舱
                    <i className={`${isActive ? "ri-check-line" : "ri-arrow-right-line"} text-sm`}></i>
                  </span>
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}